import {
  createFrontendPlugin,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';

const homePage = PageBlueprint.make({
  name: 'index',
  params: {
    path: '/',
    loader: () => import('./HomePage').then(m => <m.HomePage />),
    noHeader: true,
  },
});

export default createFrontendPlugin({
  pluginId: 'home',
  extensions: [homePage],
});
